import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { change, Field, reduxForm, SubmissionError } from 'redux-form';
import { Grid, FormControlLabel, FormLabel, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { FormCheckbox, FormError } from '../../../../components/Form/index';
import { OfficePhoneLabel, StepControl, FormWrapper, StepperTitle, FieldWrapper } from '../components';
import scrollToError from '../../../../utils/scrollToError';
import { modalsToggle } from '../../../../actions';

const submitValidation = onSubmit => values => {
  const isPurchaseOptionChosen = Object.values(values.purchase_option || {}).filter(i => i).length;

  if (!isPurchaseOptionChosen) {
    // eslint-disable-next-line no-underscore-dangle
    throw new SubmissionError({
      _error: 'At least one purchase option should be chosen'
    });
  }
  return onSubmit(values);
};

const renderCheckboxes = array =>
  array.map(({ label, name }, index) => (
    <FormControlLabel
      control={<Field name={name} component={FormCheckbox} color="primary" />}
      label={label}
      key={index}
    />
  ));

const checkBoxes = [
  {
    name: 'purchase_option.cash',
    label: 'Cash'
  },
  {
    name: 'purchase_option.company_check',
    label: 'Company Check'
  },
  {
    name: 'purchase_option.cashiers_check',
    label: "Cashier's check"
  },
  {
    name: 'purchase_option.ach_flooring',
    label: 'ACH/Flooring'
  }
];

const GridWithPadding = styled(Grid)`
  padding: 12px;
`;

const ThirdSellerStep = ({ handleSubmit, submitting, prevStep, onSubmit, toggleModal, error }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(change('registrationForm', 'purchase_option.ach_flooring', true));
  }, [dispatch])
  
  return (
    <form onSubmit={handleSubmit(submitValidation(onSubmit))}>
      <FormWrapper>
        <StepperTitle title="Purchase Option" subTitle="Step 3 of 3" />
        <Grid container spacing={24}>
          <GridWithPadding container>
            <FormLabel component="legend">Purchase Option</FormLabel>
            <Grid container>{renderCheckboxes(checkBoxes)}</Grid>
          </GridWithPadding>
          {error && <FormError msg={error} />}
          <FieldWrapper>
            <Typography>
              By clicking on the Finish button, you agree to our{' '}
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#terms" onClick={() => toggleModal('termsAndConditionsModal')}>
                Terms & Conditions
              </a>
              .
            </Typography>
          </FieldWrapper>
        </Grid>
      </FormWrapper>
      <OfficePhoneLabel />
      <StepControl prevStep={prevStep} isLoading={submitting} nextLabelText="Finish" />
    </form>
  );
};

const mapDispatchToProps = dispatch => ({
  toggleModal: key => dispatch(modalsToggle(key))
});

export default reduxForm({
  form: 'registrationForm',
  destroyOnUnmount: false,
  fields: [
    'purchase_option',
    'street',
    'city',
    'state',
    'zip',
    'region',
    'phone_number',
    'store_number',
    'secondary_contact_name',
    'secondary_contact_phone',
    'dealer_license_number',
    'dealer_license_expiry_date',
    'dealership_name',
    // 'username',
    'first_name',
    'last_name',
    'email',
    'password',
    'confirm_password',
    'role',
    'referrer'
  ],
  onSubmitFail: scrollToError
})(connect(null, mapDispatchToProps)(ThirdSellerStep));
